import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function WorkshopAbout() {
  return <section className="py-20 lg:py-32 bg-brand-cream relative overflow-hidden" data-id="element-2147">
      <div className="max-w-7xl mx-auto px-6" data-id="element-2148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="lg:hidden mb-10 text-center" data-id="element-2149">
          <SectionHeading title="Cine este Adrian Huniade și de ce a creat acest workshop gratuit" centered={true} data-id="element-2150" />
        </motion.div>

        <div className="grid lg:grid-cols-[2fr_3fr] gap-12 lg:gap-20 items-stretch" data-id="element-2151">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full max-w-[400px] mx-auto lg:mx-0 lg:max-w-none aspect-[3/4] lg:aspect-auto lg:min-h-full" data-id="element-2152">
            <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 border-[1.5px] border-brand-gold/30 rounded-full pointer-events-none" data-id="element-2153" />
            <div className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 border border-brand-gold/25 rounded-full pointer-events-none" data-id="element-2154" />
            <div className="hidden lg:block absolute -top-3 -right-3 w-2.5 h-2.5 bg-brand-gold/70 rotate-45 pointer-events-none" data-id="element-2155" />

            <div className="absolute inset-0 rounded-[32px] overflow-hidden shadow-warm" data-id="element-2156">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-2157" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-2158">
            <div className="hidden lg:block" data-id="element-2159">
              <SectionHeading title="Cine este Adrian Huniade și de ce a creat acest workshop gratuit" centered={false} data-id="element-2160" />
            </div>

            <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed mb-10" data-id="element-2161">
              <p data-id="element-2162">
                Sunt <strong data-id="element-2163">Adrian Huniade</strong> și de peste 25 de ani
                studiez și practic terapii complementare și metode de
                transformare interioară. Am început în 1997 și de atunci am
                parcurs un drum lung prin Theta Healing®, Qigong, Ho'oponopono
                și metoda Louise Hay.
              </p>
              <p data-id="element-2164">
                Sunt Instructor Internațional certificat de Theta Healing®
                Institute of Knowledge din SUA, autorizat să predau cursuri în
                întreaga lume. Sunt Facilitator Heal Your Life și Consilier de
                Dezvoltare Personală acreditat de Ministerul Muncii.
              </p>
              <p data-id="element-2165">
                Am creat acest workshop gratuit pentru că am văzut un tipar care
                se repetă: oameni cu multă informație, dar fără ghidare pas cu
                pas. Am vrut să ofer un prim pas concret și accesibil, în care
                poți experimenta direct ce înseamnă lucrul cu subconștientul,
                meditația ghidată și transformarea credințelor limitative.
              </p>

              <div className="p-6 bg-brand-purple/5 border-l-4 border-brand-purple rounded-r-xl" data-id="element-2166">
                <p className="font-subtitle italic text-xl text-brand-text" data-id="element-2167">
                  "Cursanții mei îmi spun cel mai des că simt iubirea și intră
                  ușor într-o stare de meditație pe care nu o întâlnesc în altă
                  parte."
                </p>
              </div>
            </div>

            <CTAButton className="items-start" data-id="element-2168" />
          </motion.div>
        </div>
      </div>
    </section>;
}